import { CustomStatusPanelProps } from 'ag-grid-react';
import { t } from 'i18next';
import { sum } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

import { TotalPrice } from 'core/elements';
import { useAgGridClientTableContext } from 'core/states';
import { IComponentTemplate } from 'elements/types';

interface IProps extends CustomStatusPanelProps {
  totalLabel: string;
}

export const TotalsStatusBar = ({ totalLabel = t('labelTotal') }: IProps) => {
  const [totals, setTotalPrices] = useState<{ cost: number | undefined }>({
    cost: undefined,
  });

  const classNames = 'ag-status-name-value ag-status-panel';

  const { rows } = useAgGridClientTableContext();

  const calculateTotalCost = useCallback((records: IComponentTemplate[]) => {
    const cost = sum(records.map((record) => record.extendedComputedCost)) || undefined;

    setTotalPrices({ cost });
  }, []);

  useEffect(() => {
    calculateTotalCost(rows as IComponentTemplate[]);
  }, [calculateTotalCost, rows]);

  return <TotalPrice label={totalLabel} value={totals?.cost} options={{ classNames }} />;
};
